import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "ModifyModal",
  props: {
    visibleModal: {
      type: Boolean,
      default: false,
    },
    modifyKey: {
      type: String,
      default: "cell",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    timesheetInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 24 },
        wrapperCol: { span: 24 },
      },
      modifyForm: this.$form.createForm(this, { name: "Modify Modal" }),
    };
  },
  computed: {
    ...mapState({
      ruleIntegration: (state) => state.timesheet.ruleIntegration,
    }),
    titleModal() {
      switch (this.modifyKey) {
        case "cell":
          return "Modify Cell";
        case "row":
          return "Modify Row";
        case "column":
          return "Modify Column";
        default:
          return "Confirm";
      }
    },
  },
  methods: {
    handleCancelModal() {
      this.$emit("handleCancelModal");
    },
    handleSubmit() {
      this.modifyForm.validateFields((err, values) => {
        if (err) return "";
        this.$emit("handleSubmit", values);
      });
    },
    validateValue(rule, value, callback) {
      if (parseFloat(value) > 1 || parseFloat(value) < 0) {
        callback("Value must be between 0 and 1");
      }
      callback();
    },
    disabledDate(current) {
      return (
        current < moment(this.timesheetInfo.from_date) || current > moment(this.timesheetInfo.to_date).endOf("day")
      );
    },
  },
};
